<template>
<div>
  <progress-loader customClass="pull-right" customStyle="width:100px; margin-top: -56px" ref="progress"></progress-loader>
  <div style="height: 315px; overflow-y:auto; overflow-x:hidden">
    <ul class="icons-list list">
      <li v-for="complaint in complaintList" v-bind:key="complaint.place" v-if="complaintList.length > 0">
        <div class="title font-weight-bold">{{complaint.place}}</div>
        <small class="text-ellipsis">{{complaint.description}}</small>
        <hr style="margin-bottom:10px" />
        <div class="value">
          <b-badge :variant="getComplaintStatusColor(complaint.complainStatus)">{{ complaint.complainStatus }}</b-badge>
          <br />
          <b-badge variant="light">Submitted By <router-link :to="'/settings/user/tenant/' + complaint.userProfile.uuid + '?redirect=%2Fdashboard'">{{complaint.userProfile.firstName}} {{complaint.userProfile.lastName}}</router-link></b-badge>
        </div>
        <div class="actions">
          <b-button :href="'#/complaint/' + complaint.uuid + '?redirect=%2Fdashboard'" variant="link" class="text-muted"><i class="icon-list"></i></b-button>
        </div>
      </li>
      <li class="text-center" style="padding:100px 0px" v-if="complaintList.length == 0">
        <b-badge>There's no complaint today</b-badge>
      </li>
      <li class="divider text-center">
        <b-button size="sm" href="#/complaint" variant="link" class="text-muted"><i class="icon-options"></i></b-button>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import progressLoader from '@/views/components/progressLoader'

export default {
  name: 'complaintList',
  components: {
    progressLoader
  },
  data () {
    return {
      apiUrlGetComplaintList: window.AppConfig.apiUrl + 'complain?limit=10',
      complaintList: []
    }
  },
  mounted () {
    var self = this
    setTimeout(function () {
      try {
        self.getList()
      } catch (err) {
        self.getList()
      }
      self.doAutoRefresh()
    }, Math.floor(Math.random() * 1200) + 1000)
  },
  beforeDestroy () {
    clearInterval(this.refComplaintList)
  },
  methods: {
    getComplaintStatusColor (val) {
      switch (val) {
        case 'Pending':
          return 'warning'
        case 'In Progress':
          return 'primary'
        case 'Resolved':
          return 'success'
        default:
          return 'danger'
      }
    },
    getList () {
      this.$refs.progress.activateProgressBar()
      axios.get(this.apiUrlGetComplaintList)
        .then(response => {
          if (response === undefined) return false
          this.$refs.progress.deactivateProgressBar()
          if (response !== undefined) {
            this.complaintList = response.data._embedded.complain
            for (let i = 0; i < this.complaintList.length; i++) {
              this.complaintList[i]['createdAt'] = moment(this.complaintList[i]['createdAt']).format('DD HH:mm:ss A')
            }
          } else {
            this.complaintList = []
          }
        })
        .catch(error => {
          this.$refs.progress.deactivateProgressBar()
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },

    doAutoRefresh () {
      this.refComplaintList = setInterval(() => {
        this.getList()
      }, window.AppConfig.IntervalRefreshData)
    }
  }

}
</script>


<style>
.desc, .value {
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/complaintList.vue